export interface DisplayError {
  headline: string;
  message: string;
}

export const getErrorFromStripeErrorCode = (stripeErrorCode: string | undefined) => {
  switch (stripeErrorCode) {
    case 'incorrect_zip':
      return digitalWalletErrors.incorrectZip;
    case 'incorrect_number':
      return digitalWalletErrors.incorrectCardNumber;
    case 'invalid_expiry_year':
    case 'invalid_expiry_month':
      return digitalWalletErrors.incorrectExpirationDate;
    case 'incorrect_cvc':
      return digitalWalletErrors.incorrectCvc;
    case 'payment_intent_authentication_failure':
    case 'setup_intent_authentication_failure':
      return digitalWalletErrors.multifactorAuthentication;
    default:
      return digitalWalletErrors.default;
  }
};

export const digitalWalletErrors = {
  default: {
    headline: 'Card error',
    message: 'Verify your card information is correct and try again.'
  },
  incorrectZip: {
    headline: 'Incorrect ZIP code',
    message: 'Verify your ZIP code is correct and try again.'
  },
  incorrectCardNumber: {
    headline: 'Incorrect card number',
    message: 'Verify your card number is correct and try again.'
  },
  incorrectExpirationDate: {
    headline: 'Incorrect expiration date',
    message: 'Verify your expiration date is correct and try again.'
  },
  incorrectCvc: {
    headline: 'Incorrect CVC',
    message: 'Verify your CVC is correct and try again.'
  },
  multifactorAuthentication: {
    headline: 'Multi-factor authentication failure',
    message: 'We were unable to authenticate your card.'
  },
  prepaidCard: {
    headline: 'Card error',
    message: "We don't accept prepaid cards. Please use a credit or debit card and try again."
  },
  somethingWentWrong: {
    headline: 'Something went wrong',
    message: 'We couldn’t confirm your payment. Please refresh and try again.'
  }
} as const satisfies Record<string, DisplayError>;
